<template>
	<layout-admin>
		<header class="bg-white shadow">
			<div class="py-6 px-4 sm:px-6 lg:px-8 sm:flex sm:items-center sm:justify-between gap-x-4">
				<h1 class="text-3xl font-bold leading-tight text-gray-900 flex-shrink-0">
					{{ __("Preisquellen") }}
				</h1>
				<div class="flex items-center gap-x-2">
					<input
						type="search"
						v-model="search"
						:placeholder="__('Search')"
						class="block border border-gray-300 rounded-md shadow-sm py-2 px-3 text-sm focus:outline-none focus:ring-orange-500 focus:border-orange-500 w-48"
						@input="handleSearch"
					/>

					<ui-button
						class="flex items-center flex-shrink-0"
						@click="openCreateModal()"
					>
						<font-awesome-icon :icon="['fas', 'plus']" class="mr-2 -ml-1 flex-shrink-0 h-5 w-5" />
						<span>{{ __("Preisquelle anlegen") }}</span>
					</ui-button>
				</div>
			</div>
		</header>

		<admin-table
			:rows="rows"
			:cols="cols"
			:loading="loading"
			:sort-columns="sort"
			:pagination="pagination"
			@sort-change="handleSortChange"
			@page-change="loadContent"
		>
			<template v-slot:row-actions="{ row }">
				<div class="flex items-center justify-end">
					<button @click="openEditModal(row)" class="inline-flex items-center justify-center text-orange-500 hover:bg-gray-200 rounded-lg p-2">
						<font-awesome-icon :icon="['far', 'pen-to-square']" class="h-4 w-4" />
					</button>
					<button @click="openDeleteModal(row)" class="inline-flex items-center justify-center text-orange-500 hover:bg-gray-200 rounded-lg p-2">
						<font-awesome-icon :icon="['far', 'trash']" class="h-4 w-4" />
					</button>
				</div>
			</template>
		</admin-table>
	</layout-admin>
</template>

<script>
import { debounce } from "lodash";

export default {
	data() {
		return {
			loading: true,
			rows: [],
			sort: [],
			search: "",
			pagination: {
				currentPage: 1,
				lastPage: 1,
				total: 0,
			},
			cols: [
				{ id: "name", name: this.__("Name"), sortable: true },
			],
		};
	},

	mounted() {
		this.loadContent(1);
		this.$bus.$on("content:load", this.loadContent);
	},

	beforeDestroy() {
		this.$bus.$off("content:load", this.loadContent);
	},

	methods: {
		/**
		 * @param {number} page
		 * @return {void}
		 */
		loadContent(page = 1) {
			this.loading = true;

			axios
				.get(this.$route("admin.prices.price_sources.data"), {
					params: { page, per_page: 50, sort: JSON.stringify(this.sort), search: this.search || undefined },
				})
				.then((response) => {
					this.rows                   = response.data.data;
					this.pagination.currentPage = response.data.current_page;
					this.pagination.lastPage    = response.data.last_page;
					this.pagination.total       = response.data.total;
				})
				.finally(() => {
					this.loading = false;
				});
		},

		handleSearch: debounce(function () {
			if (this.search.length > 0 && this.search.length < 3) {
				return;
			}

			this.loadContent(1);
		}, 400),

		/**
		 * @param {string} colId
		 * @return {void}
		 */
		handleSortChange(colId) {
			const idx = this.sort.findIndex((s) => s.column === colId);

			if (idx === -1) {
				this.sort.push({ column: colId, dir: "asc" });
			} else if (this.sort[idx].dir === "asc") {
				this.sort.splice(idx, 1, { column: colId, dir: "desc" });
			} else {
				this.sort.splice(idx, 1);
			}

			this.loadContent(1);
		},

		/**
		 * @return {void}
		 */
		openCreateModal() {
			this.$bus.$emit("modal:open", {
				view: {
					view: "views/Admin/PriceSourceCreate",
					data: {},
				},
			});
		},

		/**
		 * @param {Object} row
		 * @return {void}
		 */
		openEditModal(row) {
			this.$bus.$emit("modal:open", {
				view: {
					view: "views/Admin/PriceSourceCreate",
					data: { source: row },
				},
			});
		},

		/**
		 * @param {Object} row
		 * @return {void}
		 */
		openDeleteModal(row) {
			this.$bus.$emit("modal:open", {
				view: {
					view: "views/Admin/PriceSourceDelete",
					data: { id: row.id },
				},
				size: "sm",
			});
		},
	},
};
</script>
